import { Component, inject, OnInit } from '@angular/core';
import { IdentitySettingsService } from '@volo/abp.ng.identity/proxy';
import { finalize } from 'rxjs/operators';
import { ToasterService } from '@abp/ng.theme.shared';
import { ConfigStateService } from '@abp/ng.core';
import { LdapSettingsService } from '../proxy/ldap-settings.service';
import { CustomLdapSettingsDto } from './identity-ldap-settings.model';

@Component({
  selector: 'cai-ldap-login-settings',
  templateUrl: './identity-ldap-settings.component.html',
  standalone: false,
})
export class IdentityLdapSettingsComponent implements OnInit {
  settings: CustomLdapSettingsDto;

  loading = false;

  protected readonly service = inject(IdentitySettingsService);
  constructor(
    private ldapService: LdapSettingsService,
    private configState: ConfigStateService,
    private toasterService: ToasterService,
  ) {}

  ngOnInit() {
    this.ldapService.get().subscribe((settings) => (this.settings = settings));
  }

  submit(settings: CustomLdapSettingsDto) {
    this.loading = true;
    this.ldapService
      .update(settings)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(() => {
        this.toasterService.success('AbpUi::SavedSuccessfully', null);
        this.configState.refreshAppState().subscribe();
      });
  }

  isFormValid(): boolean {
    const isLdapsEnabled = this.settings.ldaps;
    const isCertificateNameEmpty =
      !this.settings.ldapsCertificateName || this.settings.ldapsCertificateName.trim() === '';

    if (isLdapsEnabled && isCertificateNameEmpty) {
      return false;
    }
    return true;
  }

  onCertificateNameChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.settings.ldapsCertificateName = input.value.trim();
  }
}
